export const dashboard = {
	pageTitle: "Dashboard",
	newToggle: "New dashboard",
	health: {
		alarms: "Active Alarms",
		offline: "Offline Devices",
		lowBattery: "Low Battery",
		valvesClosed: "Valves Closed",
	},
	charts: {
		eventTrend: "Events",
		rssi: "WiFi Signal Quality",
		battery: "Battery Levels",
		trendEmpty: "No events in the selected period",
		trendRange: {
			day: "24 h",
			week: "7 Days",
			month: "30 Days",
		},
	},
	activity: {
		header: "Activity",
	},
	device: {
		header: "Device Summary",
		typesHeader: "Device Types",
		outerRing: "Outer ring: {{label}}",
		innerRing: "Inner ring: {{label}}",
	},
	event: {
		header: "Event Summary",
	},
	user: {
		header: "User Summary",
		usersHeader: "Users",
		inactive: "Inactive",
		manage: "Manage users",
	},
	estate: {
		header: "Estate Status",
		allClear: "All zones clear",
		alarmCount_one: "{{count}} alarm",
		alarmCount_other: "{{count}} alarms",
		offlineCount_one: "{{count}} offline",
		offlineCount_other: "{{count}} offline",
	},
	analytics: {
		pin: {
			header: "Pinned Reports",
			add: "Pin Report",
			remove: "Unpin report",
			none: "No reports pinned yet. Pin a preset report to show it here.",
		},
		default: {
			header: "Select Default Chart",
			set: "Set Default",
			open: "Change Default Chart",
			set: "Set Default Chart",
		},
		noConfig:
			"You have not yet configured a default report for your dashboard. Please select one of the preset reports for this scheme to show a chart.",
		noData: "There is currently no data for this report. Make sure your device are communicating and the report is configured correctly.",
	},
};
